import { useState, useRef, useEffect } from 'react'

const Dropdown = ({
  trigger,
  children,
  align = 'right',
  className = '',
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const alignClasses = {
    right: 'right-0',
    left: 'left-0',
  }

  return (
    <div className={`relative ${className}`} ref={dropdownRef} {...props}>
      <div onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>
      
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div
            className={`absolute ${alignClasses[align]} mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-20 py-1`}
          >
            {children}
          </div>
        </>
      )}
    </div>
  )
}

export default Dropdown

